import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_HCP_ORDER_REPORT} from '../../RoutePathConstant';

const HCPOrderReport = lazy(() =>
  import('../../../screens/HCPOrderReport')
    .then(module => ({default: module.HCPOrderReport})));

const HCPOrderReportNavigation = [
  {
    path:  ROUTE_HCP_ORDER_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <HCPOrderReport />
      </Suspense>
    ),
  },
];

export default HCPOrderReportNavigation;
